import { useParams } from 'react-router-dom';
import { categories } from '@/mocks/data';
import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import Breadcrumb from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryFilter from './components/CategoryFilter';
import MovieGrid from './components/MovieGrid';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'dianying';
  const category = categories.find((c) => c.slug === currentSlug);
  const categoryName = category?.name || '未分类';

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: categoryName },
  ];

  return (
    <>
      <SEOMeta
        title={`${categoryName} - 嫩草影院高清在线免费观看 | 嫩草影院`}
        description={`嫩草影院${categoryName}频道提供海量高清${categoryName}资源，支持免费流畅在线播放，无需注册即可观看。最新${categoryName}每日更新，精彩内容不容错过。`}
        keywords={`嫩草影院${categoryName},${categoryName}在线观看,${categoryName}免费,高清${categoryName},嫩草影院`}
        canonicalUrl={`https://www.nencaoyingyuan.com/category/${currentSlug}`}
      />

      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `嫩草影院 - ${categoryName}`,
          url: `https://www.nencaoyingyuan.com/category/${currentSlug}`,
          description: `嫩草影院${categoryName}频道 - 高清${categoryName}在线观看`,
        }}
      />

      <div className="min-h-screen bg-background-950">
        <Navbar />

        <main className="pt-20 pb-14">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="mb-6">
              <Breadcrumb items={breadcrumbItems} />
            </div>

            <div className="mb-8">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">
                {categoryName}
              </h1>
              <p className="text-sm text-foreground-500">
                共为您找到相关影片，高清画质免费观看
              </p>
            </div>

            <div className="mb-8">
              <CategoryFilter active={currentSlug} />
            </div>

            <div>
              <MovieGrid categorySlug={currentSlug} />
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}